import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function FAQSection() {

  const faqs = [
    {
      question: "How can DailyPay help companies in the retail industry?",
      answer:
"DailyPay may help retailers improve turnover and retention rates by offering a benefit that improves employee wellness and engagement. Learn more about how DailyPay can improve employee retention.",  
  },

    {
      question: "How does DailyPay work with employees that don’t have a bank account?",
      answer:
"Employees who don’t use a bank account can sign up for the DailyPay Visa Prepaid Card. No preexisting bank account is needed to get early access to earned  pay using the DailyPay Card, which also unlocks instant, no-fee* access to earnings.,"    },

    {
      question: "Can seasonal staff and part time staff use DailyPay?",
      answer:
"Yes. Seasonal and part-time employees can use DailyPay and continue using the DailyPay  Card and its benefits when they leave their job or start a new job at a company that doesn’t offer DailyPay.", 
   },
  ];

  // ONLY ONE OPEN
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(index);
  };

  return (
    <section className="w-full bg-[white] py-20">

      <div className="max-w-[1050px] mx-auto px-6">

        {/* HEADING */}
        <h2
          className="
            text-center
            text-[42px]
            lg:text-[46px]
            leading-[1.05]
            text-[#220000]
            font-semibold
            lg:-mt-[60px]
          "
        >
          You Asked, We Answered.
        </h2>

        {/* FAQS */}
        <div className="mt-8">

          {faqs.map((faq, index) => {

            const isOpen = openIndex === index;

            return (

              <div
                key={index}
                className="border-t border-[#dddddd]"
              >

                {/* QUESTION */}
                <button
                  onClick={() => toggleFAQ(index)}
                  className="
                    w-full
                    flex
                    items-center
                    justify-between
                    gap-6
                    py-12
                    lg:py-5
                    font-sans
                    text-left
                    lg:text-center
                  "
                >

                  <h3
                    className="
                      text-[28px]
                      lg:text-[26px]
                      font-bold
                      text-black
                      leading-[1.3]
                    "
                  >
                    {faq.question}
                  </h3>

                  <div className="flex-shrink-0">

                    {isOpen ? (
                      <ChevronUp
                        size={34}
                        className="text-[#220000]"
                      />
                    ) : (
                      <ChevronDown
                        size={34}
                        className="text-[#220000]"
                      />
                    )}

                  </div>

                </button>

                {/* ANSWER */}
                {isOpen && (
                  <div className="pb-12 pr-12">

                    <p
                      className="
                        text-[20px]
                        lg:text-[16px]

                        leading-[1.4]
                        text-black
                        max-w-[900px]
                      "
                    >
                      {faq.answer}
                    </p>

                  </div>
                )}

              </div>
            );
          })}

          {/* LAST BORDER */}
          <div className="border-t border-[#dddddd]" />

        </div>

        {/* FOOTER TEXT */}
        <div className="mt-10">

          <p className="text-[15px] text-[#5c6780]">
            <span className="font-bold">9,10</span> Internal Database,
            March 2025
          </p>

          <p className="mt-3 text-[15px] text-[#5c6780]">
            # Fees vary by employer; login into your DailyPay account
            for more information.
          </p>

        </div>

      </div>

    </section>
  );
}